import styled from "styled-components";

export const InstallationViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: #ffffff;
  border-radius: 4px;
  min-height: 500px;
`;

// Cloud Deployment Wizard Styles
export const WizardContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
`;

export const WizardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const WizardTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  color: #2d3748;
`;

export const StepIndicator = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: #718096;
  background: #edf2f7;
  padding: 0.5rem 1rem;
  border-radius: 20px;
`;

export const WizardProgress = styled.div`
  margin-bottom: 2rem;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #4299e1 0%, #667eea 100%);
  transition: width 0.3s ease;
`;

export const StepContainer = styled.div`
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const StepTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 0.5rem;
`;

export const StepDescription = styled.p`
  font-size: 1rem;
  color: #718096;
  margin-bottom: 2rem;
`;

export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 0.5rem;
`;

export const Select = styled.select`
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  background: #fff;
  color: #2d3748;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #4299e1;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
  }

  &:disabled {
    background: #edf2f7;
    cursor: not-allowed;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
`;

export const Button = styled.button<{ variant?: "primary" | "secondary" }>`
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;

  ${(props) =>
    props.variant === "secondary"
      ? `
    background: #edf2f7;
    color: #4a5568;
    
    &:hover:not(:disabled) {
      background: #e2e8f0;
    }
  `
      : `
    background: linear-gradient(135deg, #4299e1 0%, #667eea 100%);
    color: white;
    
    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(66, 153, 225, 0.3);
    }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
`;

export const TableHeader = styled.th`
  background: #f7fafc;
  padding: 0.75rem 1rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 600;
  color: #4a5568;
  border-bottom: 2px solid #e2e8f0;
`;

export const TableRow = styled.tr<{ header?: boolean }>`
  ${(props) =>
    !props.header &&
    `
    &:hover {
      background: #f7fafc;
    }
  `}
`;

export const TableCell = styled.td`
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  color: #2d3748;
  border-bottom: 1px solid #e2e8f0;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

export const StrategyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
`;

export const StrategyCard = styled.div<{ selected?: boolean }>`
  padding: 2rem;
  border: 2px solid ${(props) => (props.selected ? "#4299e1" : "#e2e8f0")};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
  background: ${(props) => (props.selected ? "#ebf8ff" : "#fff")};

  &:hover {
    border-color: #4299e1;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(66, 153, 225, 0.2);
  }
`;

export const StrategyIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

export const StrategyTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 0.5rem;
`;

export const StrategyDescription = styled.p`
  font-size: 0.875rem;
  color: #718096;
`;

export const SummarySection = styled.div`
  background: #f7fafc;
  padding: 1.5rem;
  border-radius: 6px;
  margin-bottom: 2rem;
`;

export const SummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e2e8f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const SummaryLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: #4a5568;
`;

export const SummaryValue = styled.div`
  font-size: 0.875rem;
  color: #2d3748;
`;

export const AlertBox = styled.div<{
  variant?: "error" | "warning" | "success";
}>`
  padding: 1rem 1.5rem;
  border-radius: 6px;
  margin-bottom: 1.5rem;
  font-size: 0.875rem;

  ${(props) => {
    switch (props.variant) {
      case "error":
        return `
          background: #fff5f5;
          border: 1px solid #fc8181;
          color: #c53030;
        `;
      case "warning":
        return `
          background: #fffaf0;
          border: 1px solid #f6ad55;
          color: #c05621;
        `;
      case "success":
        return `
          background: #f0fff4;
          border: 1px solid #68d391;
          color: #2f855a;
        `;
      default:
        return `
          background: #ebf8ff;
          border: 1px solid #4299e1;
          color: #2c5282;
        `;
    }
  }}
`;

export const LoadingSpinner = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2rem 3rem;
  border-radius: 8px;
  font-size: 1.25rem;
  font-weight: 600;
  z-index: 9999;
`;
